import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import {Parts} from "components";
import API from "@beardeddevops/react.api";
import ObjectOverride from "components/ObjectOverride";
import PropTypes from "prop-types";
import {Button, Alert} from "reactstrap";
// import {parse} from 'parse-usdl';

import {confirmAlert} from "react-confirm-alert";

/**
 *  @property {Accounts_Object} state
 *  @property {object} model
 *  @property {Accounts_Properties} model.properties
 *  @property {Accounts_Is} model.is
 *  @property {Accounts_Has} model.has
 */
class Account extends ObjectOverride {
	static propTypes = {
		...Framework.Components.Object.propTypes,
	};

	constructor(props) {
		super(props, Types.Accounts._name);
		this.update = API.RequestType.UPDATE;
		this.state.showAmmoreadySuccess = false;
		this.state.showNewPassword = false;
		this.state.showPasswordRetype = false;
	}

	/**
	 * @param prevProps
	 * @param {Accounts_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		/** @type {Accounts_Object} object */
		let object = this.state;

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.name_company);
		}

		this.update = API.RequestType.UPDATE;
	}

	// noinspection JSUnusedLocalSymbols
	loadSelfAfter(data) {
		this.setState({
			pin_1: (data['pin'] || '').split('')[0] || '',
			pin_2: (data['pin'] || '').split('')[1] || '',
			pin_3: (data['pin'] || '').split('')[2] || '',
			pin_4: (data['pin'] || '').split('')[3] || ''
		});
	};


	// $(document).ready(function(){
	// 	$("#input").keydown(function(e){
	// 		if(e.which==17 || e.which==74){
	// 			e.preventDefault();
	// 		}else{
	// 			console.log(e.which);
	// 		}
	// 	})
	// });

	handleProcess(event, requestOverride) {
		if(this.update === 'POST') {this.state.password = '9999999999';}
		let result = super.handleProcess(event, requestOverride);
		this.state.pin = this.state.pin_1 + this.state.pin_2 + this.state.pin_3 + this.state.pin_4;
		return result;
	}

	/**
	 * Return TRUE to prevent handleSubmit from running afterSave(data) if already ran in the override here.
	 * @param data
	 * @param request
	 * @param suppressProcess
	 * @returns {Promise<void>}
	 */
	async afterSubmit(data, request, suppressProcess = false) {
		this.setState({
			'password': '',
			'password_new': '',
			'password_repeat': '',
		});
	}

	getSigs = async () => {
		let sigModel = new API.BuildClass(Types.Drivers_License_Scan._name, API.RequestType.READ_ALL)
		sigModel.parent = '0001-95';
		sigModel.object.pkey = this.state.pkey;
		sigModel.object.start_pkey = this.state.start_pkey;
		sigModel.object.end_pkey = this.state.end_pkey;
		sigModel.object.binary_id = this.state.binary_id;
		// sigModel.request = 'GET_CASES';
		const data = parse(this.state.start_pkey);
		// try {
		// 	sigModel.submit(null, API.RequestType.READ_ALL);
		// }
		// catch (e) {
		// }
	}

	getDavidsonAccount = async () => {
		confirmAlert({
			title: "Davidson's Account",
			message: "Click send email below for us to send an email to Davidson's with your contact information.",
			buttons: [
				{
					label: 'Send Email',
					color: 'primary',
					onClick: async () => {
						//call emailer here
						this.setState({loading: true});
						let emailModel = new API.BuildClass(Types.Davidsons._name, API.RequestType.READ);
						try {
							await emailModel.submit(null, 'GET_EMAIL_DAVIDSONS');
						} catch (error) {
						}
						this.setState({loading: false});
					}
				},
				{
					label: 'Cancel',
					color: 'danger',
					onClick: async () => {
					}
				}
			],
		});
	}

	clearAccount = async () => {
		if (this.props.rootState.isAdmin) {
			confirmAlert({
				title: 'Confirm Account Wipe',
				message: 'Are you sure you want to wipe this account?',
				buttons: [
					{
						label: 'Yes',
						color: 'danger',
						onClick: async () => {
							this.setState({loading: true});
							let teModel = new API.BuildClass(Types.Accounts._name, API.RequestType.DELETE);
							try {
								await teModel.submit(null, 'DELETE_CLEAR');
							} catch (error) {
							}
							this.setState({loading: false});
							window.location.href = '/dashboard';
						}
					},
					{
						label: 'No',
						onClick: () => {
						}
					}
				]
			});
		}
	};

	setPin = (event) => {
		let next = event.target.getAttribute('data-next');
		let newValue = event.target.value;
		if (
			newValue === '' ||
			(parseInt(newValue) >= 0 && newValue.length === 1)
		) {
			this.setState({[event.target.name]: newValue}, () => {
				if (newValue !== '' && next) {
					document.getElementsByName(next)[0].focus();
				}
			});
		}
	};

	handleKeyPress = (event) => {
		let previous = event.target.getAttribute('data-previous');
		if (event.key === 'Backspace' && previous) {
			document.getElementsByName(previous)[0].focus();
		}
	}

	validateAmmoReady = async () => {
		this.setState({loading: true});
		let arModel = new API.BuildClass(Types.Products._name, 'GET_AMMOREADY_VALIDATION');
		try {
			let result = await arModel.submit(null, 'GET_AMMOREADY_VALIDATION');
			API.Toast.success('AmmoReady Login Information has been successfully validated!', {
				position: API.Toast.POSITION.TOP_RIGHT,
				autoClose: 8000
			})

		}
		catch (e) {
		}

		this.setState({loading: false});
		// if(result) {
		// 	this.setState({showAmmoreadySuccess: true})
		// }
	}

	validateGunBroker = async () => {
		this.setState({loading: true});
		let gbModel = new API.BuildClass(Types.Products._name, 'GET_GUNBROKER_VALIDATION');
		try {
			let result = await gbModel.submit(null, 'GET_GUNBROKER_VALIDATION');
			API.Toast.success('GunBroker Login Information has been successfully validated!', {
				position: API.Toast.POSITION.TOP_RIGHT,
				autoClose: 8000
			})

		}
		catch (e) {
		}

		this.setState({loading: false});

	}

	form = () => {
		/** @type {Accounts_Properties} properties */
		let properties = this.model.properties;
		/** @type {Accounts_Object} object */
		let object = this.state;
		let {rootState } = this.props;
		return (
			<Card>
				<CardContent style={{paddingBottom: 0}}>

					<div className={"row"}>

						{/*#region Column 1*/}

						<div className={"col-md"}>

							{/*#region Company Information*/}

							<h4 className="section-title">Company Information</h4>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"Company Name"}
									value={object.name_company}
									error={object.name_company_error}
									property={properties.name_company}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							<div className={"row"}>
								<div className={"col-md"}>
									<div className="form-group">
										<Framework.Elements.PhoneNumber
											label={"Phone Number"}
											value={object.number}
											error={object.number_error}
											property={properties.number}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-md"}>
									<div className="form-group">
										<Framework.Elements.PhoneNumber
											label={"Mobile Number"}
											value={object.mobile}
											error={object.mobile_error}
											property={properties.mobile}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"Website"}
									value={object.website}
									error={object.website_error}
									property={properties.website}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"Billing ID"}
									property={properties.c_id}
									value={object.c_id}
									error={object.c_id_error}
									update={this.handleTextFieldPropertyUpdate}
									disabled={!rootState.isAdmin}
								/>
							</div>


							{/*#endregion*/}

							{/*#region Business Address*/}

							<h4 className="section-title">Business Address</h4>
							<Parts.Address
								object={object}
								properties={properties}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								hasCounty={false}
							/>

							{/*#endregion*/}

							{/*#region Authenticator App 2FA*/}

							<h4 className="section-title">Authenticator App 2FA</h4>
							<div className={'row'}>
								<div className={'col-md-12'}>
									<div className={'form-group'}>
										<span>
											<strong>Note: </strong>
											Authenticator app 2FA is managed from the Security Center.
										</span>
									</div>
								</div>
							</div>
							{this.props.rootState.isAdmin &&
								<div>
									<h4 className="section-title">Account Wipe</h4>
									<div className={'row'}>
										<Button color="danger" onClick={this.clearAccount}>Account Wipe</Button>
									</div>
								</div>
							}

							{/*#endregion*/}


							<h4 className="section-title">Kiosk & IOI PIN Code</h4>
							<div className="form-group">
								<div className={'row'}>
									<div className={'col-md'}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											name="pin_1"
											value={this.state.pin_1}
											onChange={this.setPin}
											onKeyUp={this.handleKeyPress}
											type={'number'}
											inputProps={{
												'data-next': 'pin_2',
												maxLength: 1,
												style: {
													lineHeight: '40px',
													fontSize: '40px',
													textAlign: 'center',
												}
											}}
										/>
									</div>
									<div className={'col-md'}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											name="pin_2"
											value={this.state.pin_2}
											onChange={this.setPin}
											onKeyUp={this.handleKeyPress}
											type={'number'}
											inputProps={{
												'data-previous': 'pin_1',
												'data-next': 'pin_3',
												maxLength: 1,
												style: {
													lineHeight: '40px',
													fontSize: '40px',
													textAlign: 'center',
												}
											}}
										/>
									</div>
									<div className={'col-md'}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											name="pin_3"
											value={this.state.pin_3}
											onChange={this.setPin}
											onKeyUp={this.handleKeyPress}
											type={'number'}
											inputProps={{
												'data-previous': 'pin_2',
												'data-next': 'pin_4',
												maxLength: 1,
												style: {
													lineHeight: '40px',
													fontSize: '40px',
													textAlign: 'center',
												}
											}}
										/>
									</div>
									<div className={'col-md'}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											name="pin_4"
											value={this.state.pin_4}
											onChange={this.setPin}
											onKeyUp={this.handleKeyPress}
											type={'number'}
											inputProps={{
												'data-previous': 'pin_3',
												maxLength: 1,
												style: {
													lineHeight: '40px',
													fontSize: '40px',
													textAlign: 'center',
												}
											}}
										/>
									</div>
								</div>
							</div>
							{/*<h4 className="section-title">Current FFL Boss Password</h4>*/}
							{/*<div className="form-group">*/}
							{/*	<Framework.Elements.TextField*/}
							{/*		label={"Password"}*/}
							{/*		value={object.password}*/}
							{/*		error={object.password_error}*/}
							{/*		property={properties.password}*/}
							{/*		update={this.handleTextFieldPropertyUpdate}*/}
							{/*		type={'password'}*/}
							{/*	/>*/}
							{/*</div>*/}
						</div>
						{/*#endregion*/}

						{/*#region Column 2*/}

						<div className={"col-md"}>

							{/*#region Primary User Information*/}

							<h4 className="section-title">Primary User Information</h4>

							<div className={"row"}>
								<div className={"col-md"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"First Name"}
											value={object.name_first}
											error={object.name_first_error}
											property={properties.name_first}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-md"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Last Name"}
											value={object.name_last}
											error={object.name_last_error}
											property={properties.name_last}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>

							<div className={"row"}>
								<div className={"col-md"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Title"}
											value={object.title}
											error={object.title_error}
											property={properties.title}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-md"}>
									<div className="form-group">
										<Framework.Elements.NumberField
											label={"Pin Number"}
											value={object.pin}
											error={object.pin_error}
											property={properties.pin}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>

							{/*#endregion*/}

							{/*#region Login Information*/}

							<h4 className="section-title">Login Information</h4>


							<div className="form-group">
								<Framework.Elements.EmailAddress
									label={"Email Address"}
									value={object.email}
									error={object.email_error}
									property={properties.email}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"New Password"}
									value={object.password_new}
									error={object.password_new_error}
									property={properties.password_new}
									update={this.handleTextFieldPropertyUpdate}
									type={this.state.showNewPassword ? "text" : "password"}
									InputProps={{
										endAdornment: (
											<InputAdornment position={"end"}>
												<i
													className="fa fa-eye"
													onClick={() => this.setState({ showNewPassword: !this.state.showNewPassword })}
													style={{ cursor: "pointer" }}
												/>
											</InputAdornment>
										),
										shrink: false
									}}
								/>
							</div>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"Retype Password"}
									value={object.password_repeat}
									error={object.password_repeat_error}
									property={properties.password_repeat}
									update={this.handleTextFieldPropertyUpdate}
									type={this.state.showPasswordRetype ? "text" : "password"}
									InputProps={{
										endAdornment: (
											<InputAdornment position={"end"}>
												<i
													className="fa fa-eye"
													onClick={() => this.setState({ showPasswordRetype: !this.state.showPasswordRetype })}
													style={{ cursor: "pointer" }}
												/>
											</InputAdornment>
										),
										shrink: false
									}}
								/>
							</div>

							{/*#endregion*/}

							{/*#region LEEP Login Information*/}

							<h4 className="section-title">LEEP Login Information</h4>
							<div className="form-group">
								<span>
									<strong>Note: </strong>Using the <a target={'_blank'}
									                                    href={'https://chrome.google.com/webstore/detail/ffl-boss-nics-autofill/gkcaldngjihkfdllegnaniclnpdfcaid'}><strong> FFL
									Boss eNICS Autofill plugin</strong></a> you can be automatically logged into the LEEP portal and have the
									customers background check information auto populated.
								</span>
							</div>
							<div className={"row"}>
								<div className={"col-md"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"LEEP Username"}
											value={object.leep_username}
											error={object.leep_username_error}
											property={properties.leep_username}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-md"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"LEEP Password"}
											value={object.leep_password}
											error={object.leep_password_error}
											property={properties.leep_password}
											update={this.handleTextFieldPropertyUpdate}
											type={'password'}
										/>
									</div>
								</div>
							</div>


							{/*#endregion*/}

							<h4 className="section-title">Davidson's Account Number  &nbsp; &nbsp; &nbsp;
								<Button
									color="primary"
									onClick={() => this.getDavidsonAccount()}>I don't have an account
								</Button>
							</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Davidson's Account Number"}
									value={object.davidsons_account_number}
									error={object.davidsons_account_number_error}
									property={properties.davidsons_account_number}
									update={this.handleTextFieldPropertyUpdate}
								/>

							</div>


							<h4 className="section-title">GunBroker Login Information
								&nbsp; &nbsp; &nbsp;
								{this.props.rootState.hasGunbrokerModule && object.gunbroker_username && object.gunbroker_password && <Button
									color="primary"
									onClick={() => this.validateGunBroker()}>Validate GunBroker Information (only need to test once)
								</Button>}
							</h4>
							{this.props.rootState.hasGunbrokerModule ? <div className={"row"}>
								<div className={"col-md"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"GunBroker Username"}
											value={object.gunbroker_username}
											error={object.gunbroker_username_error}
											property={properties.gunbroker_username}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-md"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"GunBroker Password"}
											value={object.gunbroker_password}
											error={object.gunbroker_password_error}
											property={properties.gunbroker_password}
											update={this.handleTextFieldPropertyUpdate}
											type={'password'}
										/>
									</div>
								</div>
							</div> : <div style={{marginBottom: '20px', cursor: 'pointer'}}
							              onClick={() => this.props.history.push('/accounts/market_place')}>Subscribe to the GunBroker Module in
								Marketplace to access this feature.</div>}

							<h4 className="section-title">AmmoReady Login Information
								&nbsp; &nbsp; &nbsp;
								{this.props.rootState.hasAmmoreadyModule && object.ammoready_username && object.ammoready_password && <Button
									color="primary"
									onClick={() => this.validateAmmoReady()}>Validate AmmoReady Information (only need to test once)
								</Button>}
							</h4>
							{this.props.rootState.hasAmmoreadyModule ?
								<div>
									<div className={"row"}>
										<div className={"col-md"}>
											<div className="form-group">
												<Framework.Elements.TextField
													label={"AmmoReady Username"}
													value={object.ammoready_username}
													error={object.ammoready_username_error}
													property={properties.ammoready_username}
													update={this.handleTextFieldPropertyUpdate}
												/>
											</div>
										</div>
										<div className={"col-md"}>
											<div className="form-group">
												<Framework.Elements.TextField
													label={"AmmoReady Password"}
													value={object.ammoready_password}
													error={object.ammoready_password_error}
													property={properties.ammoready_password}
													update={this.handleTextFieldPropertyUpdate}
													type={'password'}
												/>
											</div>
										</div>
										{this.state.showAmmoreadySuccess && <div style={{
											backgroundColor: 'green',
											color: 'white',
											padding: '10px',
											borderRadius: '4px',
											textAlign: 'center'
										}}>
											<em>Successfully Validated</em>
										</div>}
									</div>
									<div>
										{this.state.showApiKey ?
											<span>
												<div>
													{this.state.ammoready_apikey}
												</div>
												<Button
													color="primary"
													onClick={() => this.setState({showApiKey: false})}>Hide API Key
												</Button>
											</span>
											: <Button
												color="warning"
												onClick={() => this.setState({showApiKey: true})}>Show API Key
											</Button>}

									</div>
								</div>

								: <div style={{marginBottom: '20px', cursor: 'pointer'}}
								       onClick={() => this.props.history.push('/accounts/market_place')}>Subscribe to the AmmoReady Module in
									Marketplace to
									access this feature.</div>}


							<h4 style={{marginTop: '20px'}} className="section-title">ATF E-Form Login Information</h4>

							<div className={"row"}>
								<div className={"col-md"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"ATF E-Form Username"}
											value={object.e_form_username}
											error={object.e_form_username_error}
											property={properties.e_form_username}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-md"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"ATF E-Form Password"}
											value={object.e_form_password}
											error={object.e_form_password_error}
											property={properties.e_form_password}
											update={this.handleTextFieldPropertyUpdate}
											type={'password'}
										/>
									</div>
								</div>
							</div>


							{this.props.rootState.hasGunsAmericaModule &&
								<>
								<h4 style={{marginTop: '20px'}} className="section-title">GunsAmerica API Information</h4>
									<div className={"row"}>
										<div className={"col-md"}>
											<div className="form-group">
												<Framework.Elements.TextField
													label={"GunsAmerica Username"}
													value={object.gunsamerica_username}
													error={object.gunsamerica_username_error}
													property={properties.gunsamerica_username}
													update={this.handleTextFieldPropertyUpdate}
												/>
											</div>
										</div>
										<div className={"col-md"}>
											<div className="form-group">
												<Framework.Elements.TextField
													label={"GunsAmerica Password"}
													value={object.gunsamerica_password}
													error={object.gunsamerica_password_error}
													property={properties.gunsamerica_password}
													update={this.handleTextFieldPropertyUpdate}
													type={'password'}
												/>
											</div>
										</div>
									</div>
								</>
							}
						</div>


					</div>

					{/*#endregion*/}

				</CardContent>
				<CardActions>
					{/*<Button*/}
					{/*	color="primary"*/}
					{/*	data-id={'pos-submit'}*/}
					{/*	onClick={this.toggle('modalPOS')}>*/}
					{/*	<i className="fa fa-paper-plane"/>*/}
					{/*	&nbsp;&nbsp;Submit Request*/}
					{/*</Button>*/}
				</CardActions>
				<Framework.Elements.LoadingSpinner isLoading={this.state.loading}/>
			</Card>
		)
	}
}

export default Framework.Components.withRootState(Account);
